<app-dialog-warning-delete
	(passEntry)="confirmDelete($event)"
	[loading]="loading"
	[msgVald]="message"
	[mainTitle]="title">
</app-dialog-warning-delete>
